import { makeStyles } from '@rbx/ui';

const useSchemaDescriptionStyles = makeStyles()(() => ({
  descriptionContainer: {
    marginBottom: '24px',
  },
}));

export default useSchemaDescriptionStyles;
